import React from 'react';
import { BsPatchCheckFill } from 'react-icons/bs'
import './Experience.css';

const Experience = ({ t }) => {
  return (
    <section id='experience'>
      <h5>{t("experience-title")}</h5>
      <h2>{t("experience-subtitle")}</h2>

      <div className="container experience__container">

        <div className="experience__frontend">
          <h3>{t("experience-card2-title")}</h3>
          <div className="experience__content">

            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>HTML</h4>
                <small className='text-light'>{t("experience-level-experienced")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>CSS</h4>
                <small className='text-light'>{t("experience-level-experienced")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>SASS</h4>
                <small className='text-light'>{t("experience-level-intermediate")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Bootstrap</h4>
                <small className='text-light'>{t("experience-level-intermediate")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Typescript</h4>
                <small className='text-light'>{t("experience-level-experienced")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>React</h4>
                <small className='text-light'>{t("experience-level-experienced")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Redux</h4>
                <small className='text-light'>{t("experience-level-experienced")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Next JS</h4>
                <small className='text-light'>{t("experience-level-basic")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Storybook</h4>
                <small className='text-light'>{t("experience-level-intermediate")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Jest</h4>
                <small className='text-light'>{t("experience-level-experienced")}</small>
              </div>
            </article>
            
          
          </div>
        </div>

        <div className="experience__backend">
          <h3>{t("experience-card3-title")}</h3>
          <div className="experience__content">

          <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Docker</h4>
                <small className='text-light'>{t("experience-level-intermediate")}</small>
              </div>
            </article>
          <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Node JS</h4>
                <small className='text-light'>{t("experience-level-experienced")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Express</h4>
                <small className='text-light'>{t("experience-level-experienced")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>MySQL</h4>
                <small className='text-light'>{t("experience-level-experienced")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Postgres</h4>
                <small className='text-light'>{t("experience-level-experienced")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>MongoDB</h4>
                <small className='text-light'>{t("experience-level-experienced")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Nest JS</h4>
                <small className='text-light'>{t("experience-level-experienced")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Python</h4>
                <small className='text-light'>{t("experience-level-intermediate")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Django</h4>
                <small className='text-light'>{t("experience-level-basic")}</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Swagger</h4>
                <small className='text-light'>{t("experience-level-experienced")}</small>
              </div>
            </article>

          </div>
        </div>

      </div>
    </section>
  )
}

export default Experience;
